import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {updateCanvas} from '../../actions/ts_canvas_actions.js';
var ClearCanvas = React.createClass({

  onFormSubmit(event) {
    event.preventDefault();
    var {
      dispatch,
      overlay
    } = this.props;
    dispatch(clearDraw(overlay.color,overlay.color1,overlay.color2));
    dispatch(updateModal(false,null));
    dispatch(updateCanvas(null,null,[]));
  },


  render() {
    var {overlay,map,currentUser} = this.props;

    return (
      <div>
        <form id="frmLogin" role="form" onSubmit={this.onFormSubmit}>
          <div className="form-group">
          <label className="titleText" htmlFor="txtEmail">Are you sure you want to clear all?</label>
          </div>
          <button type="submit" className="buttonStyle">Clear All</button>
          <div className="form-group">
          </div>
        </form>
      </div>
    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay, map: state.map, currentUser: state.currentUser
  }
})(ClearCanvas);



// WEBPACK FOOTER //
// ./src/app/components/tools/clear.js